import { render, staticRenderFns } from "./Camera.vue?vue&type=template&id=8bcb7dc6&scoped=true"
import script from "./Camera.vue?vue&type=script&lang=js"
export * from "./Camera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcb7dc6",
  null
  
)

export default component.exports